export function setAuthToken(authToken: any) {
  return localStorage.setItem("authToken", authToken);
}

export function setMobileNo(mobileNo: string) {
  return localStorage.setItem("mobile", mobileNo);
}

export function getAuthToken() {
  return localStorage.getItem("authToken");
}

export function removeAuthToken() {
  return localStorage.removeItem("authToken");
}

export function getMobileNo() {
  return localStorage.getItem("mobile");
}

export function setReferalCode(referalCode: string) {
  return localStorage.setItem("referalCode", referalCode);
}
export function getStoreReferalCode() {
  return localStorage.getItem("referalCode");
}
export function deleteReferalCode() {
  return localStorage.removeItem("referalCode");
}
export function setUserDetails(userDetails: any) {
  return localStorage.setItem("user", userDetails);
}
export function getUserDetails(): any{
  return localStorage.getItem("user");
}
export function setUserNewDetails(userDetails:any){
  return localStorage.setItem("userDetails", userDetails);
}
export function getUserNewDetails():any{
  return localStorage.getItem("userDetails");
}
export const setLocalStorage = (key: string, value: string) =>
  localStorage.setItem(key, value);
export const getLocalStorage = (key: string) => localStorage.getItem(key);
export const removeLocalStorage = (key: string) => localStorage.removeItem(key);

export const setSource = (key:string) => localStorage.setItem("source", key);
export const getSource = (key:string) => localStorage.getItem(key);
export const removeSource = (key: string) => localStorage.removeItem(key);
export const setWithDrawableAmount = (key:any) => localStorage.setItem('withdrawAmount', key);
export const getWithDrawableAmount = (key:string) => localStorage.getItem(key);
export const removeWithDrawableAmount = (key:string) => localStorage.removeItem(key);